var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewmetroLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 450,
    height: 300,
    viewBox: "0 0 450 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.1312 1.38258C74.3923 3.83143 58.614 66.1183 30.0994 179.143C23.0229 207.193 13.3551 245.5 8.616 264.271C3.87772 283.041 0 298.759 0 299.199C0 299.687 22.0766 300 56.5714 300C87.6857 300 113.143 299.765 113.143 299.478C113.143 298.923 134.296 214.989 135.129 212.241C135.519 210.951 144.667 219.671 180.312 255.312L225.006 300L269.552 255.448C297.23 227.767 314.303 211.295 314.642 211.948C314.941 212.527 320.126 232.575 326.163 256.5L337.138 300H393.569C431.092 300 450 299.709 450 299.132C450 298.654 446.553 284.673 442.341 268.06C424.708 198.518 376.007 4.53171 375.636 2.35714C375.415 1.06114 374.988 0 374.686 0C374.385 0 340.584 33.5571 299.571 74.5714L225.003 149.143L150.311 74.454C90.9643 15.1097 75.5186 0.09772 75.1312 1.38258Z",
    fill: "url(#paint0_radial_1_6)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1_6",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-2.03631e-05 223.286) rotate(-10.3642) scale(407.361 611.041)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#721E6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.294318,
    stopColor: "#9B3382"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.862853,
    stopColor: "#004BA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#013777"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewmetroLogo);
export default __webpack_public_path__ + "static/media/newmetroLogo.2bcccdffd492e9725d43708e03d6c7c4.svg";
export { ForwardRef as ReactComponent };